import React from "react";
import { styled } from "styled-components";
import Carousel from "./Carousel";
import { Select } from "../Select";
import { Button } from "../Button";
import { ArrowLeft, ArrowRight } from "../../icons";
import { rem } from "../../utils";
const Arrows = styled.div `
  margin-top: ${rem(32)};
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const DropDown = styled.div `
  margin-top: ${rem(32)};
`;
const ArrowStatusText = styled.div `
  font-size: ${rem(18)};
`;
export const PaginatedCarousel = ({ items, currentSlide, renderItem, onChange, dropdownPlaceholder = "Choose one item", arrowStatusText = "Item {current} of {max}", nextButtonTitle = "Next", prevButtonTitle = "Previous", arrows = true, dropdown = true, ...carouselProps }) => {
    const updateCurrentSlide = (index) => {
        if (currentSlide !== index) {
            onChange(index);
        }
    };
    const prev = () => {
        if (currentSlide === 0) {
            return;
        }
        onChange(currentSlide - 1);
    };
    const next = () => {
        if (currentSlide + 1 > items.length) {
            return;
        }
        onChange(currentSlide + 1);
    };
    const compiledStatusText = arrowStatusText
        .replace("{current}", String(currentSlide + 1))
        .replace("{max}", String(items.length));
    // const chosenOptionId = items[currentSlide]?.key
    return (React.createElement("div", null,
        React.createElement(Carousel, { onChange: updateCurrentSlide, selectedItem: currentSlide, ...carouselProps }, items.map((item) => (React.createElement(React.Fragment, { key: item.key }, renderItem(item, item?.data))))),
        items.length > 0 && (React.createElement(React.Fragment, null,
            arrows && (React.createElement(Arrows, null,
                React.createElement(Button, { theme: "ghost", disabled: currentSlide === 0, onClick: prev, leadingIcon: ArrowLeft, title: prevButtonTitle }),
                React.createElement(ArrowStatusText, null, compiledStatusText),
                React.createElement(Button, { theme: "ghost", disabled: currentSlide === items.length - 1, onClick: next, leadingIcon: ArrowRight, title: nextButtonTitle }))),
            dropdown && (React.createElement(DropDown, null,
                React.createElement(Select, { label: "", placeholder: dropdownPlaceholder, options: items, optionValueFn: (option) => option.key, optionTitleFn: (option) => option.title, value: "", onChange: (event) => {
                        if (event.target.value) {
                            const index = items.findIndex((item) => String(item.key) === event.target.value);
                            onChange(index);
                        }
                    } })))))));
};
export default PaginatedCarousel;
//# sourceMappingURL=PaginatedCarousel.js.map